export default __webpack_public_path__ + "static/media/Amber1.45e10e47.mp3";